/**
 * imageTransitionUtils.js
 * Helper functions to improve image loading transitions
 */

// Flag to track when returning to the home page
let isReturningToHomePage = false;

/**
 * Set up listener to detect navigation events
 */
export const initializeNavigationTracking = () => {
  if (typeof window !== 'undefined' && !window._transitionTrackingInitialized) {
    window._transitionTrackingInitialized = true;
    
    // Track navigation history for smooth transitions
    window.addEventListener('popstate', () => {
      const isHomePage = window.location.pathname === '/' || window.location.pathname === '';
      isReturningToHomePage = isHomePage && sessionStorage.getItem('hasVisitedHome') === 'true';
      
      if (isReturningToHomePage) {
        console.log('Returning to home page - enabling instant image display');
        document.documentElement.classList.add('returning-to-home');
        
        // Remove the class after animations complete
        setTimeout(() => {
          document.documentElement.classList.remove('returning-to-home');
        }, 1000);
      }
    });
    
    // Always mark that we've visited home if we're on it
    if (window.location.pathname === '/' || window.location.pathname === '') {
      sessionStorage.setItem('hasVisitedHome', 'true');
    }
  }
};

/**
 * Check if we're currently returning to the home page
 */
export const isReturningToHome = () => {
  return isReturningToHomePage;
};

/**
 * Reset the returning to home flag
 */
export const resetReturningToHomeFlag = () => {
  isReturningToHomePage = false;
};

/**
 * Apply instant image transitions to all bike category elements
 */
export const applyInstantBikeCategoryImages = () => {
  if (typeof document === 'undefined') return;
  
  document.querySelectorAll('.option2').forEach(el => {
    // Remove any transition temporarily for instant display
    el.style.transition = 'none';
    el.classList.add('loaded');
    
    // Force reflow
    void el.offsetWidth;
    
    // Restore transition after a short delay
    setTimeout(() => {
      el.style.transition = '';
    }, 100);
  });
};

const imageTransitionUtils = {
  initializeNavigationTracking,
  isReturningToHome,
  resetReturningToHomeFlag,
  applyInstantBikeCategoryImages
};

export default imageTransitionUtils;